import { Component, EventEmitter, Input, Output } from '@angular/core'
import { Router } from '@angular/router';
import { UnitMenu } from 'src/app/core/models/module/unit-menu.dto';
import { SendInfoComponentService } from 'src/app/core/services/local/send-info.component.service';
import { StringUtilsHelper } from '../../helpers/strings.helper';

@Component ({
    selector: 'app-button-modules',
    templateUrl: './button-modules.component.html',
    styleUrls: ['./button-modules.component.scss']
})

export class ButtonModules {
    @Input() link: string = '';
    @Input() title: string = '';
    @Input() icon: string = '';
    @Input() formId: number;
    @Input() unit?: UnitMenu;
    @Input() specialityId?: number;
    @Input() disabled: boolean = false;
    @Output() clickEvent? = new EventEmitter<any>();

    constructor(private executeSend: SendInfoComponentService, private router: Router){

    }

    getIcon(icon: string): string{
        let resp ='fa-light fa-house-medical';
        if (icon !== null && icon !== "")
            return "fa-light " + icon;
        return resp;
    }

    private getUrl(url: string): string{
        let resp= '/home';
        if(url !='')
            return '../' + url;
        return resp;
    }

    onClickMenu(url: string){
        let urlT = this.getUrl(url);
        if (StringUtilsHelper.notNullOrUndefinedOrEmpty(this.unit) && this.unit.typeId === 1) {
            if (StringUtilsHelper.notNullOrUndefinedOrEmpty(this.specialityId)) {
                this.clickEvent.emit({url: url, formId: this.formId, specialityId: this.specialityId, title: this.title });
            } else {
                this.executeSend.sendObject(this.unit, url.concat("/specialities"));
            }
        } else {
            this.executeSend.sendObject({formId: this.formId, title: this.title, unitId: this.unit.id }, url);
        }
        this.router.navigate([urlT]);
    }
}
